import axios from '@/utils/axios'
const api = {
    fetchProducts: '/company/merchantProducts',
    fetchBrands: '/company/brands',
    fetchAddresses: '/company/merchant/addresses',
    fetchBrandById: '/company/brands',
    fetchTaskById: '/company/tasks',
    fetchApply: '/company/task/applys'
}

/**
 * 新增任务
 * @returns {Promise<any>}
 */
export function addTask (params) {
    return new Promise((resolve, reject) => {
        axios.post(api.fetchTaskById, { ...params })
            .then(response => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    })
}
/**
 * 查询子任务
 * @returns {Promise<any>}
 */
export function fetchApply (id) {
    return new Promise((resolve, reject) => {
        axios.get(api.fetchApply + '/' + id)
            .then(response => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    })
}
/**
 * 核销权益
 * @returns {Promise<any>}
 */
export function profitCancel (id) {
    return new Promise((resolve, reject) => {
        axios.put(api.fetchApply + '/' + id + '/submitPass')
            .then(response => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    })
}
/**
 * 修改任务
 * @returns {Promise<any>}
 */
export function editTask (params) {
    return new Promise((resolve, reject) => {
        axios.put(`${api.fetchTaskById}/${params.id}`, { ...params })
            .then(response => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    })
}
/**
 * 获取品牌下所有商品
 */
export function fetchProductsByBrand (params) {
    return new Promise((resolve, reject) => {
        axios.get(api.fetchProducts, { params }).then(res => {
            resolve(res.data)
        }).catch(err => {
            reject(err)
        })
    })
}
/**
 * 获取品牌详情
 */
export function fetchBrandById (id) {
    return new Promise((resolve, reject) => {
        axios.get(api.fetchBrands + '/' + id).then(res => {
            resolve(res)
        }).catch(err => {
            reject(err)
        })
    })
}
/**
 * 获取品牌下拉框数据
 */
export function fetchBrandsSelectionBox (params) {
    return new Promise((resolve, reject) => {
        axios.get(api.fetchBrands, { params }).then(res => {
            resolve(res.data)
        }).catch(err => {
            reject(err)
        })
    })
}
/**
 * 获取品牌下店铺
 * @returns {Promise<any>}
 */
export function fetchAddresses (params) {
    return new Promise((resolve, reject) => {
        axios.get(api.fetchAddresses, { params })
            .then(response => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
    })
}
/**
 * 获取店铺详情
 * @returns {Promise<any>}
 */
export function fetchAddressById (id) {
    return new Promise((resolve, reject) => {
        axios.get(api.fetchAddresses + '/' + id)
            .then(response => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
    })
}
/**
 * 根据id查询任务
 * @param id {String}
 * @return {Promise<unknown>}
 */
export function fetchTasks (params) {
    return new Promise((resolve, reject) => {
        console.log('pppp', params)
        axios.get(api.fetchTaskById, { params }).then(res => {
            resolve(res.data)
        }).catch(err => {
            reject(err)
        })
    })
}
/**
 * 根据id查询任务
 * @param id {String}
 * @return {Promise<unknown>}
 */
export function fetchTaskDetail (id) {
    return new Promise((resolve, reject) => {
        axios.get(api.fetchTaskById + '/' + id).then(res => {
            resolve(res.data)
        }).catch(err => {
            reject(err.msg || '未知错误')
        })
    })
}
